import type { FC } from "react";
import React from "react";

import { Button } from "@react/ui-primitives/button";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@react/ui-primitives/drawer";
import {
  Field,
  FieldContent,
  FieldError,
  FieldLabel,
} from "@react/ui-primitives/field";
import { Input } from "@react/ui-primitives/input";

import { useManualEntryForm } from "../hooks/useManualEntryForm.ts";

// oxlint-disable-next-line no-warning-comments
// TODO(APT-254): per-instance ids (useId) instead of hardcoded globals.
const NAME_ID = "manual-name";

const CALORIES_ID = "manual-calories";

interface ManualEntrySheetProps {
  readonly onOpenChange: (open: boolean) => void;
  readonly open: boolean;
}

export const ManualEntrySheet: FC<ManualEntrySheetProps> = ({
  onOpenChange,
  open,
}) => {
  const form = useManualEntryForm({
    onSaved: () => {
      onOpenChange(false);
    },
  });

  return (
    <Drawer onOpenChange={onOpenChange} open={open}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Log a purchase</DrawerTitle>
        </DrawerHeader>
        <form
          className="flex flex-col gap-4 px-4 pb-8"
          onSubmit={form.handleSubmit}
        >
          <fieldset className="contents" disabled={form.state.isSubmitting}>
            <Field>
              <FieldLabel htmlFor={NAME_ID}>Name</FieldLabel>
              <FieldContent>
                <Input
                  id={NAME_ID}
                  placeholder="Custom item"
                  {...form.register("name")}
                />
                <FieldError errors={[form.state.errors.name]} />
              </FieldContent>
            </Field>
            <Field>
              <FieldLabel htmlFor={CALORIES_ID}>Calories</FieldLabel>
              <FieldContent>
                <Input
                  id={CALORIES_ID}
                  inputMode="numeric"
                  placeholder="kcal"
                  {...form.register("calories")}
                />
                <FieldError errors={[form.state.errors.calories]} />
              </FieldContent>
            </Field>
            <Button
              disabled={!form.state.isValid}
              onClick={form.handleSubmit}
              type="submit"
            >
              Add to queue
            </Button>
          </fieldset>
        </form>
      </DrawerContent>
    </Drawer>
  );
};
